module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ed.571df496.png";